/**
 * 榜单活动核心流程的封装
 */
;(function(win, UpAct) {
    define(function(require, exports, module) {
        var Base = require('c-base');
        var Fastclick = require('c-fastclick');
        var native = require('c-up-native');

        var Activity = require('./base/activity');

        const MSL = ["MA", "AE", "AF", "BH", "CY", "DJ", "DZ", "EG", "IL", "IQ", "JO", "KM", "KW", "LB", "LY", "MR", "OM", "PK", "PS", "QA", "SA", "SD", "SO", "SS", "SSD", "SY", "TN", "TR", "UG", "YE"];

        const AppBase = Base.extend({
            defaults: {
                title: '',
                wrap: '#wrap'
            },

            initialize: function() {
                this.Parent.apply(this, arguments);
                
                FastClick.attach(document.body);

                let title = this.get('title');

                title && UpAct.BaseUtil.setTitle(title);
                
                this.bindEvent();
            },

            bindEvent: function() {
                let wrap = $(document.body);

                wrap.delegate('[node-id=profile]', 'click', (e) => {
                    this.goProfile(e);
                });
            },

            goProfile(e) {
                let target = e.currentTarget;
                let uid = $(target).attr('data-uid');
                let country = $(target).attr('data-country');
                let platform = native.getPlatform();
                if (country && UpAct.lang.langType == 'areg' && MSL.indexOf(country) < 0) {
                    return;
                }

                if (uid) {
                    
                    if (platform == "uplive") {
                        native.profile({
                            uid: uid
                        });
                    } else {
                        UpLive.invoke('profile',{uid});
                    };
                    
                }
            },

            // 用户活动数据
            getActInfo() {
                this.loadActData();
            },

            // 活动信息
            loadActData() {
                let activity = new Activity({
                    url: UpAct.CONFIG.getActInfo()
                });

                let promise = activity.getData();

                promise.done((actData) => {
                    UpAct.actData = actData
                    this.emit('getActInfo');
                });

                promise.fail(() => {
                    $(this.get('wrap')).empty();
                    UpAct.notification.simple('activity error');
                });
            }
        });

        UpAct.AppBase = AppBase;
    });
})(window, window['UpAct'] || (window['UpAct'] = {}));



// WEBPACK FOOTER //
// ./js/component/app.js